import { useEffect, useState } from 'react';
import { toast } from 'sonner';

const VERSION = process.env.REACT_APP_BUILD_VERSION || 'dev';

/**
 * Listens for service-worker activation events and shows a discreet
 * "New version available" toast with a "Reload now" action.
 * Mounted once at the App root.
 */
export const VersionUpdateListener = () => {
  const [shown, setShown] = useState(false);
  useEffect(() => {
    if (!('serviceWorker' in navigator)) return;
    const onMessage = (e) => {
      if (e.data && e.data.type === 'SW_ACTIVATED' && e.data.version && e.data.version !== VERSION && !shown) {
        setShown(true);
        toast.message('A new version is available', {
          description: `Build: ${e.data.version}`,
          duration: Infinity,
          action: {
            label: 'Reload now',
            onClick: () => window.location.reload(),
          },
        });
      }
    };
    navigator.serviceWorker.addEventListener('message', onMessage);
    return () => navigator.serviceWorker.removeEventListener('message', onMessage);
  }, [shown]);
  return null;
};

export default VersionUpdateListener;
